/**
 * Convierte un timestamp de Firestore a objeto Date
 * @param {Object} timestamp - Timestamp de Firestore con _seconds y _nanoseconds
 * @returns {Date} Objeto Date
 */
const convertirFirestoreTimestamp = (timestamp) => {
    
    // Si ya es un objeto Date, devolverlo directamente
    if (timestamp instanceof Date) return timestamp;
    
    // Si es un string o un número, convertirlo a Date
    if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      return new Date(timestamp);
    }
    
    // Si es un timestamp de Firestore (con _seconds y _nanoseconds)
    if (timestamp && typeof timestamp === 'object') {
      if (timestamp._seconds !== undefined && timestamp._nanoseconds !== undefined) {
        // Convertir segundos a milisegundos y añadir nanosegundos convertidos a milisegundos
        return new Date(timestamp._seconds * 1000 + timestamp._nanoseconds / 1000000);
      }
      
      // Si tiene toDate() (otro formato posible de Firestore)
      if (typeof timestamp.toDate === 'function') {
        return timestamp.toDate();
      }
    }
    
    // Si no se puede convertir, devolver la fecha actual
    console.warn("No se pudo convertir el timestamp:", timestamp);
    return new Date();
  };
  
  /**
   * Formatea una fecha en formato español completo con día, mes, año, hora y minutos
   * @param {Object|string|Date} fecha - La fecha a formatear (acepta timestamp de Firestore)
   * @returns {string} Fecha formateada en español con formato completo
   */
  //"DD de MMMM de YYYY, HH:MM AM/PM"
export const formatearFechaCompleta = (fecha) => {
    if (!fecha) return 'Fecha no disponible';
    
    
    // Asegurar que sea un objeto Date
    const date = convertirFirestoreTimestamp(fecha);
    
    // Imprimir información detallada para depuración

    
    // Formatear con opciones específicas
    return date.toLocaleString('es-CO', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Bogota' // Especificar la zona horaria de Colombia
    });
  };
  
  /**
   * Formatea una fecha en formato español corto (solo día, mes y año)
   * @param {Object|string|Date} fecha - La fecha a formatear (acepta timestamp de Firestore)
   * @returns {string} Fecha formateada en español con formato corto (DD/MM/YYYY)
   */
  //"DD/MM/YYYY"
export const formatearFechaCorta = (fecha) => {
    if (!fecha) return 'Fecha no disponible';
    
    const date = convertirFirestoreTimestamp(fecha);
    
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  
  
  /**
   * Formatea un precio añadiendo el símbolo de euro
   * @param {number} precio - El precio a formatear
   * @returns {string} Precio formateado con símbolo de euro
   */
  //"$ XX.XXX"
export const formatearPrecio = (precio) => {
    if (precio === undefined || precio === null) return 'Precio no disponible';
    
    // Usando el API Intl.NumberFormat para formatear moneda colombiana
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0, // Los pesos colombianos generalmente no usan decimales
      maximumFractionDigits: 0
    }).format(precio);
  };

//formatear fecha para servicio de parciales, quices, etc
//"DD/MM HH:MMAM"
export const formatearFechaHora = (fecha) => {
  if (!fecha) return 'Fecha no disponible';
  
  const date = convertirFirestoreTimestamp(fecha);
  
  return date.toLocaleString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Bogota'
  });
};
  
//formatear fecha para servicios con entregas antes de fecha
//DD/MM antes de HH:MMAM
export const formatearFechaAntesDe = (fecha) => {
  if (!fecha) return 'Fecha no disponible';
  
  // Asumiendo que esta función ya la tienes para convertir el timestamp a Date
  const date = convertirFirestoreTimestamp(fecha);
  
  // 1. Formatear la fecha: 06/01
  const diaMes = date.toLocaleDateString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'America/Bogota'
  });
  
  // 2. Formatear la hora: 11:00 am/pm
  // Usamos 'en-US' momentáneamente para obtener "am/pm" limpio sin los puntos de "a. m."
  const hora = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Bogota'
  }).toLowerCase();
  
  return `${diaMes} antes de las ${hora}`;
};

// Función para formatear porcentajes
export const formatPercent = (value) => {
    if (typeof value !== 'number') return '0%';
    return `${(value * 100).toFixed(1)}%`;
};

//funcion para imagenes pdfs
export const cargarImagen = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
};

export const toYYYYMMDD = (date) => {
    return date.toISOString().split('T')[0];
};